import { useDispatch, useSelector } from 'react-redux';

import { initializeReviews as initializeReviewsConnect } from '../../../../../actions/business';
import API from '../../../../../libs/api';
import { selectBusinessType, selectBusinessId } from '../../../../../selectors';

function useReviews() {
  const dispatch = useDispatch();
  const businessType = useSelector(selectBusinessType);
  const businessId = useSelector(selectBusinessId);

  async function refreshReviews() {
    const result = await API.getReviews(businessId, businessType);
    const { data } = result;
    dispatch(initializeReviewsConnect(data));
    return data;
  }

  return { refreshReviews };
}

export default useReviews;
